<template>
  <base-sheet :visible="visible" @close="$emit('cancel')">
    <div class="vxl-sheet__head">
      <span class="vxl-sheet__icon" :style="{ color: iconColor }">
        <i class="material-icons">{{ icon }}</i>
      </span>
      <div class="vxl-sheet__head-text">
        <h3 class="vxl-sheet__title">{{ title }}</h3>
        <p v-if="itemName" class="vxl-sheet__item">{{ itemName }}</p>
      </div>
    </div>

    <p class="vxl-sheet__subtitle desc">{{ description }}</p>

    <button type="button" class="vxl-sheet__action vxl-sheet__action--danger" @click="$emit('confirm')">
      <i class="material-icons">{{ confirmIcon }}</i>
      {{ confirmLabel }}
    </button>
    <button type="button" class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('cancel')">
      {{ dismissLabel }}
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

// Confirmação de remover conteúdo baixado — e, trocando os textos, de cancelar
// um download em andamento (ver askConfirm em services/download/downloadSheets).
export default {
  name: 'ConfirmRemoveDownload',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    itemName: { type: String, default: null },
    icon: { type: String, default: 'delete' },
    title: { type: String, default: 'Remover dos downloads?' },
    description: {
      type: String,
      default: 'Você não conseguirá acessar esse conteúdo quando estiver offline.'
    },
    dismissLabel: { type: String, default: 'Cancelar' },
    confirmLabel: { type: String, default: 'Remover' },
    confirmIcon: { type: String, default: 'delete_outline' }
  },
  computed: {
    // Vermelho só quando a ação apaga arquivo de verdade. Cancelar um download
    // em andamento é âmbar — interrompe, mas não destrói o que o usuário tinha.
    iconColor () {
      return this.icon === 'cancel' ? '#f9a825' : '#ff5252';
    }
  }
};
</script>

<style scoped>
.desc {
  margin-top: 12px;
}
</style>
